var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    stroke: "#691e78",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;40",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    stroke: "#691e78",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;40",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.0565e800ffca236ea2ee546ec3bd4eb6.svg";
export { ForwardRef as ReactComponent };